import { useMemo } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-image-gallery/styles/css/image-gallery.css";
import dayjs from "dayjs";
import { Badge, Card, CardBody, Col, Container, Row } from "reactstrap";
import Loader from "../../Components/Common/Loader";
import { useQuestion } from "../../hooks/useQuestions";

import { registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const QuestionsDetails = (props) => {
  document.title = "Questions/Réponses détail";

  const { id } = useParams();
  const questionQ = useQuestion(id);

  const question = questionQ.data || null;
  const response = useMemo(() => question?._response || [], [question]);

  if (questionQ.isLoading) {
    return <Loader />;
  }

  if (questionQ.isError) {
    return (
      <Loader
        error={questionQ.error?.message || props.t("Erreur lors du chargement")}
      />
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Détail question/réponse")}
          pageTitle={props.t("Questions/Réponses")}
        />
        <Row className="g-3">
          <Col lg={12}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                  <h5 className="mb-0">{props.t("Question")}</h5>
                  <Badge color={question?.responded ? "success" : "warning"}>
                    {question?.responded ? props.t("Répondu") : props.t("En attente")}
                  </Badge>
                </div>
                <p className="mb-3">{question && question.question_text}</p>
                {question?.question_pic ? (
                  <img
                    src={question.question_pic}
                    className="rounded"
                    style={{ maxWidth: "100%", maxHeight: "320px" }}
                    alt={props.t("Illustration question")}
                  />
                ) : null}
                <div className="text-muted mt-2">
                  {question && dayjs(question.request_date).format("DD-MM-YYYY")}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={8}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <h5 className="mb-3">{props.t("Réponses")}</h5>
                {response.length === 0 ? (
                  <p className="text-muted mb-0">{props.t("Aucune réponse pour le moment.")}</p>
                ) : (
                  response.map((item, key) => (
                    <div key={key} className="border rounded p-3 mb-3">
                      <p className="mb-2">{item.response_text}</p>
                      <div className="text-muted small">
                        {dayjs(item.response_date).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  ))
                )}
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="shadow-sm border-0 mb-3">
              <CardBody>
                <h5 className="mb-3">{props.t("Informations du particulier")}</h5>
                {question && question.requestor && (
                  <div>
                    <div>
                      {question.requestor.profile &&
                        `${question.requestor.profile.first_name || ""} ${
                          question.requestor.profile.last_name || ""
                        }`.trim()}
                    </div>
                    <div>{question.requestor.profile && question.requestor.profile.user_type}</div>
                    <div>
                      {question.requestor.profile &&
                        `${question.requestor.profile.city || ""} , ${
                          question.requestor.profile.country || ""
                        }`}
                    </div>
                    <div>{question.requestor.email}</div>
                  </div>
                )}
              </CardBody>
            </Card>
            <Card className="shadow-sm border-0">
              <CardBody>
                <h5 className="mb-3">{props.t("Intervenants")}</h5>
                {response &&
                  response.map((item, key) => (
                    <div key={key} className="border rounded p-2 mb-2">
                      <div>
                        {item.responder &&
                          item.responder.profile &&
                          `${item.responder.profile.first_name || ""} ${
                            item.responder.profile.last_name || ""
                          }`.trim()}
                      </div>
                      <div>{item.responder && item.responder.email}</div>
                      <div>
                        {item.responder &&
                          item.responder.profile &&
                          item.responder.profile.user_type}
                      </div>
                    </div>
                  ))}
                {!response?.length ? (
                  <p className="text-muted mb-0">{props.t("Aucun intervenant.")}</p>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
QuestionsDetails.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(QuestionsDetails));
